import React, { useState, useEffect } from "react";
import { Card, Form } from "react-bootstrap";
import ErrorComponent from "../../../Components/ErrorMessage";
import MobileMultiMatrixQuestion from "./MobileMatrixMulti";
import { replacePlaceholder } from "../../../Utils/Utils";

const MatrixMultiChoiceQuestionCard = ({ question, formValues, setFormValues, showError }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const questionText = replacePlaceholder(question.questionText, formValues);
  const getRowValues = (rowIndex) => {
    const rowKey = `${question.tempId}_r${rowIndex + 1}`;
    const rowData = formValues[question.tempId]?.find(item => item[rowKey]);
    return rowData ? rowData[rowKey] : [];
  };
  const getFlatValues = () => {
    const flatValues = {};
    const matrixValues = formValues[question.tempId] || [];
    
    matrixValues.forEach(rowObj => {
      const rowKey = Object.keys(rowObj)[0];
      flatValues[rowKey] = rowObj[rowKey];
    });
    
    return flatValues;
  };
  const flatValues = getFlatValues();
  //const hasAnswer = Object.keys(formValues).some((key) => key.startsWith(`${question.tempId}_r`) && formValues[key].some((value) => value !== ""));
  const hasAnswer = Object.keys(flatValues).some(
    key => flatValues[key].some(value => value !== "")
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // working code as old
  // const handleCheckboxChange = (e, rowIndex, colIndex) => {
  //   const isChecked = e.target.checked;
  //   const value = e.target.value;
  //   const key = `${question.tempId}_r${rowIndex + 1}`;
  //   const prevValues = formValues[key] || [];
  //   let questionColumns = [...question.columns];
  //   let newValues;
  //   if (isChecked) {
  //     newValues = [...prevValues, value];
  //   } else {
  //     newValues = prevValues.filter((v) => v !== value);
  //   }
  //   let finalValues = questionColumns.map(option => newValues.includes(option) ? option : '');
  //   setFormValues((prevState) => ({
  //     ...prevState,
  //     [key]: finalValues,
  //   }));
  // };




 const handleCheckboxChange = (e, rowIndex) => {
    const isChecked = e.target.checked;
    const value = e.target.value;
    const rowKey = `${question.tempId}_r${rowIndex + 1}`;

    setFormValues(prev => {
      const currentAnswers = prev[question.tempId] || [];
      const rowAnswer = currentAnswers.find(a => a[rowKey]) || { [rowKey]: [] };
      
      const updatedValues = isChecked
        ? [...rowAnswer[rowKey], value]
        : rowAnswer[rowKey].filter(v => v !== value);

      return {
        ...prev,
        [question.tempId]: [
          ...currentAnswers.filter(a => !a[rowKey]),
          { [rowKey]: updatedValues }
        ]
      };
    });
  };
  if (isMobile) {
    return (
      <MobileMultiMatrixQuestion
        question={question}
        formValues={formValues}
        handleCheckboxChange={handleCheckboxChange}
        showError={showError}
      />
    );
  }

  return (
    <Card className={`mt-3 ${question.isMandatory && showError && !hasAnswer ? "border-danger" : ""}`}>
      <Card.Body>
        <Form>
          <Form.Group>
            <div className="d-flex flex-column">

              <Form.Label>
                <b style={{whiteSpace: 'pre-wrap',wordBreak: 'break-word'}}>
                {question.tempId}.{questionText}
                  {question.isMandatory && <span className="text-danger">*</span>}
                </b>
              </Form.Label>
              <Form.Label>
                <b style={{ color: 'lightblue' }}>{question.questionDescription}</b>
              </Form.Label>
              {question.isMandatory && showError && !hasAnswer && (
                <ErrorComponent message={question.requiredErrorText} />
              )}
            </div>
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th></th>
                    {question.columns.map((column, index) => (
                      <th key={index}>{column}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {question.rows.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      <td>{row}</td>
                      {question.columns.map((column, colIndex) => (
                        <td key={colIndex}>
                          <Form.Check
                            type="checkbox"
                            id={`${question.tempId}_${rowIndex}_${colIndex}`}
                            name={`${question.tempId}_${rowIndex}_${colIndex}`}
                            value={column}
                            // label={column}
                           checked={flatValues[`${question.tempId}_r${rowIndex + 1}`]?.includes(column) || false}
                            onChange={(e) => handleCheckboxChange(e, rowIndex, colIndex)}
                          />
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Form.Group>


        </Form>
      </Card.Body>
    </Card>
  );
};

export default MatrixMultiChoiceQuestionCard;

